import React from 'react';
import { ContactFilters as ContactFiltersType } from '../../../config/api';

interface ContactFiltersProps {
  filters: ContactFiltersType;
  onChange: (filters: Partial<ContactFiltersType>) => void;
}

const ContactFilters: React.FC<ContactFiltersProps> = ({ filters, onChange }) => {
  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'lead', label: 'Lead' },
    { value: 'qualified', label: 'Qualified' },
    { value: 'converted', label: 'Converted' },
    { value: 'archived', label: 'Archived' }
  ];

  const typeOptions = [
    { value: '', label: 'All Types' },
    { value: 'individual', label: 'Individual' },
    { value: 'company', label: 'Company' }
  ];

  const handleFilterChange = (key: keyof ContactFiltersType, value: string) => {
    onChange({ [key]: value || undefined });
  };

  return (
    <div className="flex flex-row items-center gap-3">
      {/* Status Filter */}
      <div className="min-w-40">
        <select
          value={filters.status || ''}
          onChange={(e) => handleFilterChange('status', e.target.value)}
          className="block w-full h-10 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-lex-accent focus:border-lex-accent text-sm"
        >
          {statusOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Type Filter */}
      <div className="min-w-36">
        <select
          value={filters.contact_type || ''}
          onChange={(e) => handleFilterChange('contact_type', e.target.value)}
          className="block w-full h-10 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-lex-accent focus:border-lex-accent text-sm"
        >
          {typeOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Clear Filters */}
      {(filters.status || filters.contact_type || filters.assigned_user_id || filters.tags) && (
        <button
          onClick={() => onChange({})}
          className="px-3 py-2 h-10 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors whitespace-nowrap"
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default ContactFilters; 